import type { IKybBusinessStatus } from './status-screen';

export type ActiveBusinessReviewNotice = 'more-data' | 'open' | 'pending';

/**
 * The compliance review of an already-approved business, which stays in the normal app instead of
 * the verification screens. Undefined when there is nothing to tell the business.
 */
export const activeBusinessReviewNotice = (
  status?: IKybBusinessStatus | null
): ActiveBusinessReviewNotice | undefined => {
  if (status?.status !== 'Active') {
    return undefined;
  }

  switch (status.review?.reviewStatus) {
    case 'RequestedMoreData':
      return 'more-data';
    case 'Open':
      return 'open';
    case 'PendingForReview':
      return 'pending';
    default:
      return undefined;
  }
};
